import { styled } from '@linaria/react';

import { TextareaField } from '~shared/ui/organisms/TextareaField';

export const StyledTextareaField = styled(TextareaField)`
	min-height: 15rem;
`;
